import { AdjacentTankBM } from 'src/types/BusinessModel/Vessel/AdjacentTankBM';
import { AdjacentTank } from 'src/types/ViewModel/Vessel/AdjacentTank';

export class AdjacentTankFactory {
    constructor() {}
    public getAdjacentTank(adjacentTank: AdjacentTankBM): AdjacentTank {
        return new AdjacentTank(adjacentTank.adjacentTankId, adjacentTank.side);
    }
}
